import React, { FC, ReactNode } from 'react'
import { Link } from 'react-router-dom';

//css 
import '../../../../_jutemplate/assets/css/custom.css'

interface NavigateButtonProps {
  children:ReactNode;
  to:string
}

export const NavigateButton:FC<NavigateButtonProps> = ({children,to:url}) => {
  return (
    <Link to={url} className='btn py-1 px-8 rounded-3 dashboard-navigate-button'>
        {children}
    </Link>
  )
}




